export default "__VITE_ASSET__A2HgfzwM__"